import { Http } from "../Http";
import { AxiosPromise } from "axios";
import { getUserAccessToken } from "../selectors/Accounts";

export default class OrderService {
	
	public static  customerOrdersGetByFilter(input: any) {
		var obj = JSON.stringify(input);
		return Http.axios().post('/api/Shop/getcustomerorders', obj, { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static orderGetByFilter(input: any) {
		var obj = JSON.stringify(input);
		return Http.axios().post('/api/Shop/GetSubscriptionsByUser', obj, { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

}